// extracted by mini-css-extract-plugin
export default {"wrapper":"d0TKSDcgO0jGHUCUcFLg","deleteButton":"VgJmmKcZXfkWYC7vB4mz","deleteIcon":"ZhwE6yAp6y6JHK6ecopI"};